var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NutrientBalanceTable',{attrs:{"columns":_vm.columns,"details":_vm.details}})}
var staticRenderFns = []

export { render, staticRenderFns }